<app-selector label="Learning Game" [data]="learningGameCoreService.learningGameList$| async" displayKey="name"
    [formControl]="ctrl" (refreshEvent)="refresh()" [loading]="learningGameCoreService.loading$ | async" [hint]="hint">
</app-selector>
